"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _stringField = _interopRequireDefault(require("./stringField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var stringArrayField = function stringArrayField() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return value.map(function (element) {
    var formattedString = (0, _stringField["default"])(element);
    return formattedString.replace(/,/g, '_');
  }).join(',');
};

var _default = stringArrayField;
exports["default"] = _default;